import React, {Component} from 'react'
import {BrowserRouter, Route, Switch} from 'react-router-dom'
import Navigation from './components/Navigation'
import LogIn from './components/LogIn'


class NotFound extends Component {
render(){
    return(
        <h3>404 - Not Found</h3>
    )
}
}

const Routes = () => {
    return (    
    <BrowserRouter>
    <Switch>
    <Route exact path="/" component={LogIn} />
    <Route exact path="/navigation" component={Navigation} />
    <Route exact path="*" component={NotFound} />
    </Switch>
    </BrowserRouter>
    )
};

export default Routes;


// WEBPACK FOOTER //
// ./src/routes.js